import React, { useMemo } from "react";
import { Link } from "gatsby";

const MoodGenreGrid = () => {
    const items = useMemo(() => [
        { label: "Chill", value: "chill" },
        { label: "Commute", value: "commute" },
        { label: "Energize", value: "energize" },
        { label: "Feel-good", value: "feel-good" },
        { label: "African", value: "african" },
        { label: "Arabic", value: "arabic" },
        { label: "Blues", value: "blues" },
        { label: "Bollywood & Indian", value: "bollywood-indian" },
        { label: "Romance", value: "romance" }
    ], []);

    return (
        <>
            <h2 className="mb-[25px] flex items-center justify-center gap-3 text-center text-2xl font-bold">Moods & genres</h2>
            <div className="mb-10 grid grid-cols-1 gap-x-6 gap-y-3 md:grid-cols-2 lg:grid-cols-3">
                {items.map(({ label, value }) => (
                    <Link
                        key={label}
                        className="group flex overflow-hidden rounded-md"
                        to={`/search?q=${encodeURIComponent(value)}`}
                    >
                        <span className="w-3 bg-sky-300"></span>
                        <span className="flex-1 bg-gray-800 py-3 text-center text-white group-hover:bg-gray-700">
                            {label}
                        </span>
                    </Link>
                ))}
            </div>
        </>
    );
};

export default React.memo(MoodGenreGrid);
